import { render, staticRenderFns } from "./BottomNavContainer.vue?vue&type=template&id=91f8505e&scoped=true"
import script from "./BottomNavContainer.vue?vue&type=script&lang=js"
export * from "./BottomNavContainer.vue?vue&type=script&lang=js"
import style0 from "./BottomNavContainer.vue?vue&type=style&index=0&id=91f8505e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f8505e",
  null
  
)

export default component.exports